import React from "react";
import Ofertahome from "../components/user/home/Ofertahome";

const Oferta = () => {
  return (
    <div>
      <Ofertahome />
    </div>
  );
};

export default Oferta;
